<script setup lang="ts">
import { computed } from "vue"
import DashboardBadge from "./DashboardBadge.vue"

const props = withDefaults(
  defineProps<{
    field?: string
    label?: string
    tooltip?: string
  }>(),
  {
    field: "",
    label: "N/A",
    tooltip: ""
  }
)

const displayLabel = computed(() => props.label.toUpperCase())
const tooltipText = computed(() => {
  if (props.tooltip) {
    return props.tooltip
  }

  return props.field ? `${humanize(props.field)} was not emitted by the source data.` : ""
})

function humanize(value: string): string {
  return value
    .replaceAll("-", " ")
    .replaceAll("_", " ")
    .replace(/^\w/, (letter) => letter.toUpperCase())
}
</script>

<template>
  <DashboardBadge :label="displayLabel" :tooltip="tooltipText" tone="neutral" class="dashboard-null-badge" />
</template>
